window.Drupal.behaviors.loginDatalayers = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", () => {
      const btnLogin = document.querySelector('.login-user-form-btn')
      btnLogin?.addEventListener('click', handleClickLogin);
      btnLogin?.addEventListener('mousedown', handleClickLogin);


      function handleClickLogin(event) {
        event.preventDefault();

        dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Login',
          'event_action': 'Submit',
          'event_label': 'Login_submit'
        })
      }
    })
  }
}